"use client";

import PrimaryButton from "@/app/[locale]/components/buttons/PrimaryButton";
import Title1 from "@/app/[locale]/components/typography/Title1";
import { CousrsDetailsType } from "@/app/types";
import { sortArrayBySequence } from "@/app/utils/sorting";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { Link } from "@/app/config/navigation";
import React, { useState } from "react";

const getCourseUrl = (course: any) => {
  return course.name 
    ? course.name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
    : course.id;
};

function CourseMainSection({ course }: CourseMainSectionPropsType) {
  const [activeAge, setAge] = useState(0);
  const ages = ["7-10", "10-12", "12-14"];
  const t = useTranslations("courses");

  return (
    <div className="lg:flex lg:items-center h-auto md:h-[1100px] relative lg:h-[58.75rem] ">
      <div className="relative z-10 container  h-full lg:h-auto pt-[19rem] lg:pt-0">
        <Title1 className="flex w-fit relative max-sm:max-w-[300px] gap-[17px] lg:max-w-[920px]  items-center lg:gap-2 lg:gap-4  mb-4">
          {course?.courseIconUrl && (
            <Image
              alt={`Icon for ${course?.name}`}
              src={course?.courseIconUrl}
              width={35}
              height={35}
              className="w-[35.72px]   object-contain h-[35.72px] lg:h-[5.45rem] lg:w-[5.45rem]"
            />
          )}
          <span>{course?.name}</span>
          <div
            className="absolute  lg:h-[30px] end-0 bottom-[-27px] text-white lg:text-[1.25rem] flex justify-center items-center text-[12px] px-4 h-[22px] w-fit"
            style={{ background: course?.color }}
          >
            {t("age")} <span className="">{course?.ageRange}</span>
          </div>
        </Title1>
        {false ? (
          <div className="flex items-center gap-4 mb-14 lg:gap-[3rem]">
            <p className="text-[14px] lg:text-[1.62rem] font-bold">
              Choose Age:
            </p>
            <div className="bg-primary rounded-[30px] lg:px-[.5rem] px-[10px] py-[7px] lg:py-[0.6rem]">
              <div className="relative  font-bold  text-white   flex  text-[12px] lg:text-[1.8rem]">
                {ages?.map((age, index) => (
                  <div
                    key={index}
                    onClick={() => setAge(index)}
                    className={`relative  z-10 cursor-pointer   flex justify-center transition-all  ease-in duration-200 lg:w-[6.25rem] w-[60px] ${
                      index == activeAge && "  text-primary"
                    }`}
                  >
                    7-10
                  </div>
                ))}
                <div
                  className={`absolute h-full top-0 lg:w-[6.25rem] w-[60px] bg-white rounded-[30px] z-0 transition-all  ease-in duration-200 `}
                  style={{ left: `${(activeAge * 100) / ages.length}%` }}
                ></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="relative py-11"></div>
        )}
        <p className="text-[1.6rem] font-light text-[#220859] mb-7">
          {t("ableTo")}
        </p>
        <div>
          {sortArrayBySequence(course?.courseOutcomes)?.map((outcome, i) => (
            <p
              key={i}
              className="text-[14px] lg:text-[1.5rem] lg:max-w-[58rem] font-medium mb-1"
            >
              <span
                style={{ color: course.color }}
                className="pe-2 text-secondary lg:text-[1.8rem] text-[16px] inline-block lg:min-w-[25px] min-w-[12px] "
              >
                {i + 1}
              </span>
              {outcome.description}
            </p>
          ))}
        </div>
        <div
          className=" 
      relative
        lg:hidden
        w-full 
        h-[400px]

          "
        >
          {course?.courseHeaderImgUrl && (
            <Image
              className="object-contain"
              alt={`${course?.name} header image`}
              fill
              src={course?.courseHeaderImgUrl}
            />
          )}
        </div>
        <div className="flex gap-8  w-auto lg:static  lg:gap-16 lg:mt-20 lg:top-auto md:top-[980px]  top-[727px] ">
          <Link href={`/courses/${getCourseUrl(course)}/enroll`} className="">
            <PrimaryButton
              type="button"
              className=" bg-secondary font-bold	 flex gap-16	"
            >
              <div> {t("enrollNow")}</div>
              <div className="font-medium">
                {course?.groupMonthlyPrice}€{t("monthly")}
              </div>
            </PrimaryButton>
          </Link>
          <Link href={`/courses/${getCourseUrl(course)}#about`}>
            <PrimaryButton
              type="button"
              className=" bg-orangeLight font-bold  "
            >
              {t("browseDetails")}
            </PrimaryButton>
          </Link>
        </div>
      </div>
      <div
        className=" 
       absolute  
        start-1/2 md:translate-x-0 -translate-x-1/2 end-[18%] lg:bottom-0 t  lg:top-[13rem]  top-[279px] bg-center  	z-0
        h-[328px]
       bottom-auto
        lg:w-[35.4rem]
        lg:h-[40.5rem]
        md:top-[429px]
        lg:block
        hidden
        md:start-[11%]
        lg:end-[13%]

        lg:start-auto
        w-[287px]
      mt-[97px]
      lg:mt-0

          "
      >
        {course?.courseHeaderImgUrl && (
          <Image
            className="object-contain"
            alt={`${course?.name} header image`}
            fill
            src={course?.courseHeaderImgUrl}
          />
        )}
      </div>
    </div>
  );
}

export default CourseMainSection;
type CourseMainSectionPropsType = {
  course: CousrsDetailsType;
};



